<template>
  <div class="task-detail">
    <NavBtn
      :on-click="giveup"
    />
    <div class="detail">
      <!-- <img class="icon" :src="detail.icon" alt=""> -->
      <span class="icon" :style="{backgroundImage: `url(${detail.icon})`}"></span>
      <div class="info">
        <div><span>{{detail.reward}}</span><span>元 奖励</span></div>
        <span>剩余时间 </span>
        <count-down ref="count" v-if="detail.deadline > 0" :deadline="(detail.deadline * 1000)" format="mm:ss"></count-down>
      </div>
    </div>
    <div class="steps">
      <div class="order">第一步</div>
      <div class="block-1">
        <div class="desc">
          <div>前往 App Store 搜索关键词：</div>
          <div>“{{detail.keyword}}”</div>
          <div>找到本应用下载，排名约在第 <span>{{detail.rank}}</span> 位</div>
        </div>
        <div class="go-store">
          <div class="btn-small" @click="goAppstore">前往</div>
        </div>
      </div>
      <div class="order">第二步</div>
      <div class="block-2">
        <div class="remind">
          <div>点击试玩，联网试玩 <span>{{detail.playtime}}</span> 分钟</div>
          <div>打开应用时必须“允许网络”</div>
        </div>
        <div class="open">
          <div class="btn-small" :class="{'disabled': hasOpenAppStore === 0}" @click="_openApp()">试玩</div>
        </div>
      </div>
    </div>
    <div class="btn-middle shadow reward" :class="{'disabled': isReward}" @click="reward()">领取奖励</div>
    <GiveupDialog ref="giveup" :task-id-give="taskId" />
    <OvertimeDialog ref="overtime" />
    <RewardDialog ref="reward" />
    <AppstorePopup ref="appstore" />
  </div>
</template>
<style lang='scss' scoped>
  .task-detail {
    background-color: #3A4E92;
    height: 100%;
    padding-top: 86px;

    .back {
      position: absolute;
      top: 16px;
      left: 20px;
      width: 40px;
      height: 40px;
      background: #342F74;
      box-shadow: 0 3px 5px 0 #36308E;
      border-radius: 50%;
    }

    .giveup {
      position: fixed;
      height: 20px;
      line-height: 20px;
      top: 26px;
      left: 20px;
      font-size: 14px;
      color: #FFFFFF;
      text-decoration: underline;

      @include regular();
    }

    .detail {
      margin-left: 20px;
      margin-bottom: 30px;
      height: 72px;
      display: flex;
      align-items: center;

      .icon {
        width: 72px;
        height: 72px;
        margin-right: 12px;
        border-radius: 16px;
        display: inline-block;
        background-size: 72px 72px;
      }

      .info {
        display: inline-block;

        span:first-child {
          font-size: 36px;
          color: #FFFFFF;

          @include roboto();
        }

        span:nth-child(2) {
          font-size: 13px;
          color: #FFFFFF;

          @include semibold();
        }

        span:nth-child(3) {
          font-size: 13px;
          color: #FFFFFF;

          @include semibold();
        }

        div:nth-child(2) {
          font-size: 13px;
          color: #FFFFFF;

          @include regular();
        }
      }
    }

    .steps {
      margin-left: 20px;
      margin-bottom: 40px;

      .order {
        font-size: 16px;
        color: #FFFFFF;
        height: 22px;
        line-height: 22px;
        margin-bottom: 10px;

        @include semibold();
      }

      .block-1 {
        background-color: #FFFFFF;
        box-shadow: 0 3px 5px 0 #2C2683;
        border-radius: 8px;
        width: 335px;
        height: 121px;
        display: flex;
        align-items: center;
        padding: 16px 16px 16px 15px;
        margin-bottom: 20px;

        .desc {
          div:first-child {
            font-size: 13px;
            color: #3A3A3A;
            margin-bottom: 10px;

            @include regular();
          }

          div:nth-child(2) {
            font-size: 24px;
            color: #3A3A3A;
            margin-bottom: 10px;

            @include semibold();
          }

          div:last-child {
            font-size: 13px;
            color: #3A3A3A;

            span {
              color: #EF4F2A;
              @include semibold();
            }

            @include regular();
          }
        }

        .go-store {
          flex: 1;
          text-align: right;
        }
      }

      .block-2 {
        width: 335px;
        height: 78px;
        background: #FFFFFF;
        box-shadow: 0 3px 5px 0 #2C2683;
        border-radius: 8px;
        padding: 16px 16px 16px 15px;
        display: flex;
        align-items: center;

        .remind {
          div:first-child {
            font-size: 13px;
            color: #3A3A3A;
            margin-bottom: 10px;

            span {
              color: #EF4F2A;

              @include semibold();
            }

            @include regular();
          }

          div:nth-child(2) {
            font-size: 13px;
            color: #3A3A3A;

            @include regular();
          }
        }

        .open {
          flex: 1;
          text-align: right;
        }
      }
    }

    .reward {
      margin: 0 auto;
      color: #F75946;

      &.disabled {
        color: #AAAAAA;
      }
    }
  }
</style>
<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { $toast, $loading } from '@/views/common/Loading.js'
  import GiveupDialog from './GiveupDialog'
  import OvertimeDialog from './OvertimeDialog'
  import RewardDialog from './RewardDialog'
  import AppstorePopup from './AppstorePopup'
  import CountDown from '@/components/CountDown.vue'
  import { openAPP, relayPlugInstalls } from '../../assistant/JSBridge'
  import { URI_APPTASK_DETAIL, URI_APPTASK_CHECK_STATUS } from '@/store/modules/dashboard/type'

  export default {
    components: {
      GiveupDialog,
      OvertimeDialog,
      RewardDialog,
      CountDown,
      AppstorePopup
    },
    data () {
      return {
        taskId: 0,
        hasOpenAppStore: 0,
        isReward: true
      }
    },
    computed: {
      ...mapState({
        detail: state => state.dashboard.taskDetail,
        check_task_status: state => state.dashboard.taskStatus
      })
    },

    watch: {
      'check_task_status.status': function (v) {
        if (this.check_task_status.status === 3) {
          this.$refs.reward.show()
          this.$refs.count.stop()
          this.hasOpenAppStore = 0
          this.isReward = true
          $storage.remove('HAS_OPEN_APP_STORE')
          $storage.remove('HAS_OPEN_APP')
        }
      }
    },

    async mounted () {
      this.taskId = this.$route.params.id
      let res = await this.getDetail({
        tid: this.taskId
      })
      if (res && res.data.err_code > 0) {
        if (res.data.err_code === 10001) {
          $toast.show('红包任务超时，请重新领取', 1000)
          setTimeout(() => {
            this.$store.commit('dashboardState', { key: 'taskDetail', val: {} })
            $router.push('/dashboard')
          }, 1000)
        }
      }
      if (($storage.get('HAS_OPEN_APP_STORE') + '') === '1') {
        this.hasOpenAppStore = 1
      }
      if ($storage.get('HAS_OPEN_APP')) {
        this.isReward = false
      }
    },

    methods: {
      ...mapMutations(['dashboardState']),
      ...mapActions({
        getDetail: URI_APPTASK_DETAIL,
        checkStatusTask: URI_APPTASK_CHECK_STATUS
      }),
      back () {
        $router.push('/dashboard')
      },
      goAppstore () {
        $storage.set('HAS_OPEN_APP_STORE', 1)
        this.hasOpenAppStore = 1
        // this.$refs.appstore.show()
        let url = 'hbxdas://openurl?url=' + this.detail.open_url
        window.location.href = url
      },
      _openApp () {
        if (this.hasOpenAppStore === 0) {
          return
        }
        let bid = this.detail.bundle_id
        let ack_openapp_link = this.detail.ack_openapp_link
        let ack_bought_link = this.detail.ack_bought_link

        relayPlugInstalls([bid], ack_bought_link).then(() => {
          openAPP(bid, ack_openapp_link).then((res) => {
            if (res['status'] !== 'ok') {
              this.isReward = true
              return $toast.show('应用未下载完或下载错误，请确认后再试', 2000)
            }
            $storage.set('HAS_OPEN_APP', 1)
            this.isReward = false
          })
        })
      },
      async reward () {
        if (this.isReward) {
          return
        }
        let taskId = this.$route.params.id
        const checkStatus = (taskId) => {
          $loading.show('正在领取')
          return this.checkStatusTask({ tid: taskId })
            .then(res => res.data.payload)
            .then((payload) => {
              // if (payload.status === 5) { // 任务未开始
              //   $toast.show('请打开App试玩～', 1000)
              // }
              if (payload.status === 4) { // 任务时间已到但是未完成
                setTimeout(() => {
                  checkStatus(taskId)
                }, payload.wait_time)
              }
              if (payload.status === 3) { // 任务已完成
                $loading.hide()
                this.$store.commit('dashboardState', { key: 'taskStatus', val: payload })
              }
              if (payload.status === 5 || payload.status === 2) { // 任务进行中
                $toast.show('试玩时间没到，继续试玩才能领红包', 2000)
              }
              if (payload.status === 1) { // 无进行中的任务
                if (payload.msg) {
                  $toast.show(payload.msg, 2000)
                } else {
                  $toast.show('红包任务超时，请重新领取', 1000)
                }
                $storage.remove('HAS_OPEN_APP_STORE')
                $storage.remove('HAS_OPEN_APP')
                setTimeout(() => {
                  this.$store.commit('dashboardState', { key: 'taskDetail', val: {} })
                  $router.push('/dashboard')
                }, 1000)
              }
            })
        }
        checkStatus(taskId)
      },
      giveup () {
        this.$refs.giveup.show()
      }
    }
  }
</script>
